import React from 'react';
import MaterialIcon from '@mui/material/Icon';
import { resourceIconMap } from 'utils';
import { Tooltip } from '@mui/material';


export default ({
  name,
  type = 'fa',
  // eslint-disable-next-line no-unused-vars
  childrenClassName = '',
  className = '',
  resource = '',
  tooltip = '',
  ...props
}) => {
  let iconName = name;
  if (resource) {
    iconName = resourceIconMap(resource);
  }

  const icon = (
    type === 'material'
      ? (<MaterialIcon {...props} className={className}>{iconName}</MaterialIcon>)
      : (<i {...props} className={`fa fa-${iconName} ${className || ''}`} />)
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip} enterDelay={500}>
        {icon}
      </Tooltip>
    );
  }
  return icon;
};
